import { EventListener } from "./EventListener";
var globalListeners = [];
var EventsManagerClass = /** @class */ (function () {
    function EventsManagerClass() {
        this._listeners = [];
    }
    EventsManagerClass.prototype.addEventListener = function (type, context, callback, global) {
        var listeners = global ? globalListeners : this._listeners;
        if (listeners.filter(function (listener) { return listener.type === type; }).map(function (listener) { return listener.callback; }).indexOf(callback) === -1) {
            listeners.push(new EventListener(type, callback, context));
        }
    };
    EventsManagerClass.prototype.removeEventListener = function (type, context, global) {
        var listeners = global ? globalListeners : this._listeners;
        var index = -1;
        for (var i = 0, listenersLength = listeners.length; i < listenersLength; i += 1) {
            var currentListener = listeners[i];
            if (currentListener.type === type && currentListener.context === context) {
                index = i;
                break;
            }
        }
        if (index !== -1) {
            listeners.splice(index, 1);
        }
    };
    EventsManagerClass.prototype.dispatchEvent = function (type, data, global) {
        var listeners = global ? globalListeners : this._listeners;
        for (var i = 0; i < listeners.length; i += 1) {
            var currentListener = listeners[i];
            if (currentListener.type === type) {
                currentListener.callback.call(currentListener.context, data);
            }
        }
    };
    EventsManagerClass.prototype.getGlobalEventListeners = function () {
        return globalListeners;
    };
    return EventsManagerClass;
}());
export var EventsManager = typeof window["EventsManager"] === "undefined" ? EventsManagerClass : window["EventsManager"];
window["EventsManager"] = EventsManager;
//# sourceMappingURL=EventsManager.js.map